import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Fetch_Document } from "../../../../API/api";
import TitleValue from "../seeker/TitleValue";
import StaticTableAnt from "../../../AntDesignTable/StaticTableAnt";
import { Spin, Tooltip, Checkbox, Button } from "antd";
import CountUp from "react-countup";
import { momentit } from "../../../../utils";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { SyncOutlined } from "@ant-design/icons";
import { bindActionCreators } from "redux";
import { Actions } from "../../../../Action";
import { ReactComponent as ViewIcon } from "../../../../Icons/totalView.svg";
import PdfIcon from '../../../../Icons/pdfDark.svg'
import svgVideo from '../../../../Icons/videoDark.svg'
import ImgVideo from '../../../../Icons/imageDark.svg'
import threadIcon from '../../../../Icons/newThread.svg'
import crawIcon from '../../../../Icons/crawl.svg'
{/* <ViewIcon /> */ }
// import { Card, Input, Tag, Tooltip } from "antd";
const containerStyle = {
  width: "100%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};

const renderPara = (title) => {
  return (
    <div style={{ textAlign: "center" }}>
      <span style={{
        fontSize: "13px",
        color: "#2A364A",
        fontWeight: "500",
      }}>{title}</span>
    </div>
  );
};

function TitleValueToolTip(title, data) {
  return (
    <Tooltip
      title={() => {
        return <span style={{ color: "black", fontSize: "14px" }}>{data}</span>;
      }}
      color="#FFF"
    >
      <span style={{ fontWeight: "500", fontSize: "17px" }}>{title}</span>
    </Tooltip>
  );
}

function DocumentTable() {
  const [channelName, setChannelName] = React.useState("");
  const [documentData, setDocumentData] = React.useState(null);
  const documentUserType = useSelector((state) => state.documentTab);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showMore, setShowMore] = useState();
  const [channelId, setChannelId] = useState("");
  const [channel, setChannel] = useState(false);
  const [slackData, setSlackData] = useState(null);
  const [slackCurrentPage, setSlackCurrentPage] = useState(1);
  const [threadRefresh, setThreadRefresh] = useState(false);
  const dispatch = useDispatch();
  const { setReload } = bindActionCreators(Actions, dispatch);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [sortInfo, setSortInfo] = useState({});
  const { geoLevelId, geoLevelValue, domainId, check } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );

  const slackThread = (value, channelName) => {
    setChannel(true);
    setChannelId(value);
    setChannelName(channelName);
    fetchData(value, true);
  };
  const docTypes = [...new Set(documentData?.map((item) => item.docType))]?.map(
    (val) => {
      return {
        text: val,
        value: val,
      };
    }
  );
  const transformedDocTypes = docTypes?.map((docType) => {
    const splitText = docType.text.split(" ")[0];
    return {
      text: splitText,
      value: docType.value,
    };
  });

  const columnsData = [
    {
      title: TitleValue("Date Ingested"),
      dataIndex: "dateIngested",
      align: "left",
      width: 100,
      defaultSortOrder: "descend",
      sorter: (a, b) => a?.dateIngested - b?.dateIngested,
      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              zIndex: 999,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            {renderPara(momentit(raw?.dateIngested))}
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Doc Name"),
      dataIndex: "docName",
      sorter: (a, b) => a?.docName?.localeCompare(b?.docName),
      align: "left",
      width: 250,

      render: (_, raw) => (
        <>
          {/* {raw?.docType && raw?.docType?.split(" ")[0] === "Thread" ? (
            <span
              style={{
                fontSize: "13px",
                color: "#2A364A",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                // color: "#0D6EFD",
                textDecoration: "underline",
              }}
              onClick={() => slackThread(raw?.docName, raw?.channelName)}
            >
              <span>{raw.channelName}</span>
            </span>
          ) : (
            <span
              style={{
                fontSize: "13px",
                color: "#2A364A",
                fontWeight: "500",
              }}
            >
              {raw?.docName}
            </span>
          )} */}
          {raw?.docType && raw?.docType?.split(" ")[0] === "Thread" ? (
            <span
              style={{
                fontSize: "13px",
                // color: "#2A364A",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#0D6EFD",
                textDecoration: "underline",
              }}
              onClick={() => slackThread(raw?.docName, raw?.channelName)}
            >
              <span>{raw.channelName}</span>
            </span>
          ) : (
            <span
              style={{
                fontSize: "13px",
                color: "#2A364A",
                fontWeight: "500",
              }}
            >
              {raw?.docName}
            </span>
          )}
        </>
      ),
    },
    {
      title: "Doc Type",
      dataIndex: "docType",
      align: "center",
      width: 100,
      sorter: (a, b) => a?.docType?.localeCompare(b?.docType),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const handleCheckboxChange = (checkedValue, isChecked) => {
          if (isChecked) {
            setSelectedKeys([...selectedKeys, checkedValue]);
          } else {
            setSelectedKeys(selectedKeys.filter((key) => key !== checkedValue));
          }
        };

        return (
          <div style={{ padding: 8 }}>
            {transformedDocTypes.map((option) => (
              <div
                key={option.value}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 4, // Reduced space between checkboxes
                }}
              >
                <Checkbox
                  value={option.value}
                  checked={selectedKeys.includes(option.value)}
                  onChange={(e) =>
                    handleCheckboxChange(option.value, e.target.checked)
                  }
                  style={{ marginRight: 8 }} // Reduced space between checkbox and label
                />
                <span>{option.text}</span>
              </div>
            ))}
            <Button
              type="primary"
              onClick={() => {
                confirm();
                setDropdownVisible(false);
              }}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
                setDropdownVisible(false);
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </div>

        );
      },
      onFilter: (value, record) => {
        // Handle the case when value is an array (multiple selected values)
        if (Array.isArray(value)) {
          return value.some((v) => record.docType.includes(v));
        }
        return record.docType.includes(value);
      },
      render: (_, raw) => (
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tooltip
            color="#fff"
            title={() => (
              <span style={{ color: "black", textTransform: "capitalize" }}>
                {raw?.docType?.split(" ")[0]}
              </span>
            )}
          >
            {raw?.docType?.split(" ")[0] === "Pdf" ? (
            
              <img
                width="47px"
                height="23px"
                src={PdfIcon}
                alt="pdf"
              />
            ) : raw?.docType?.split(" ")[0] === "Video" ? (

              <img
                width="20"
                height="20"
                src={svgVideo}
                alt="video"
              />

            ) : raw?.docType?.split(" ")[0] === "Image" ? (
              <img
                width="20"
                height="20"
                src={ImgVideo}
                alt="image"
              />
            ) : raw?.docType?.split(" ")[0] === "Crawled" ? (
              <img
                width="20"
                height="20"
                src={crawIcon}
                alt="url"
                style={{
                  filter: "grayscale(100%) brightness(0.3)", // Makes it gray and dimmer
                  opacity: 0.6, // Slight transparency like the video icon
                }}
              />
            ) : raw?.docType?.split(" ")[0] === "Thread" ? (
              <img
                width="20"
                height="20"
                src={threadIcon}
                alt="thread"
                style={{
                  filter: "grayscale(100%) brightness(0.5)", // Makes it gray and dimmer
                  opacity: 0.6, // Slight transparency like the video icon
                }}
              />
            ) : (
              "-"
            )}
          </Tooltip>
        </span>
      ),
    },

    {
      title: TitleValueToolTip(
        "Total Views",
        "Total Views of the Document Paragraphs across searches"
      ),
      dataIndex: "totalViews",
      sorter: (a, b) => a?.totalViews - b?.totalViews,
      align: "center",
      width: 100,
      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
              gap: "5px",
              marginLeft: "10px"
            }}
          >
            <CountUp end={raw.totalViews} />
            <ViewIcon />
            {/* <VidoIcon/> */}
            {/* {raw.TrendingViews} */}
          </span>
        </>
      ),
    },
    {
      title: TitleValueToolTip(
        "Unique Searches",
        "Number of times document paragraphs appeared in searches"
      ),
      dataIndex: "uniqueSearches",
      sorter: (a, b) => a?.uniqueSearches - b?.uniqueSearches,
      align: "center",
      style: { fontSize: "13px", fontWeight: "300" },
      width: 100,
      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
            }}
          >
            {/* {raw.uniqueSearches} */}
            <CountUp end={raw?.uniqueSearches} />
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Paragraphs"),
      dataIndex: "paragraphs",
      sorter: (a, b) => a?.paragraphs - b?.paragraphs,
      align: "center",
      style: { fontSize: "13px", fontWeight: "300" },
      width: 100,
      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              display: "flex",
              width: "50%",
              justifyContent: "flex-end",
              textAlign: "right",
            }}
          >
            <CountUp end={raw?.paragraphs} />
          </span>
        </>
      ),
    },
  ];

  const slackColumnData = [
    {
      title: TitleValue("Date Ingested"),
      dataIndex: "dateIngested",
      align: "left",
      width: 100,
      defaultSortOrder: "descend",
      sorter: (a, b) => a?.dateIngested - b?.dateIngested,
      render: (_, raw) => (
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            zIndex: 999,
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          {renderPara(momentit(raw?.dateIngested))}
          {/* {renderPara(momentit(new Date(raw.dateIngested * 1000)))} */}
        </span>
      ),
    },
    {
      title: TitleValue("Date (From)"),
      dataIndex: "fromDate",
      align: "left",
      width: 100,
      defaultSortOrder: "descend",
      sorter: (a, b) => a?.fromDate - b?.fromDate,
      render: (_, raw) => (
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            zIndex: 999,
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          {renderPara(momentit(raw?.fromDate))}
          {/* {momentit(new Date(raw.fromDate * 1000))} */}
        </span>
      ),
    },
    {
      title: TitleValue("Date (To)"),
      dataIndex: "toDate",
      align: "left",
      width: 100,
      defaultSortOrder: "descend",
      sorter: (a, b) => a?.toDate - b?.toDate,
      render: (_, raw) => (
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            zIndex: 999,
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          {renderPara(momentit(raw?.toDate))}
          {/* {momentit(new Date(raw.toDate * 1000))} */}
        </span>
      ),
    },
    {
      title: TitleValue("Total Views"),
      dataIndex: "totalView",
      sorter: (a, b) => a?.totalViews - b?.totalViews,
      align: "center",
      width: 100,
      render: (_, raw) => (

        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
            gap: "5px",
            marginLeft: "10px"
          }}
        >
          <CountUp end={raw.totalViews} />
          <ViewIcon />
          {/* {raw.TrendingViews} */}
        </span>
      ),
    },
    {
      title: TitleValue("Unique Searches"),
      dataIndex: "uniqueSearch",
      sorter: (a, b) => a?.uniqueSearches - b?.uniqueSearches,
      align: "center",
      style: { fontSize: "13px", fontWeight: "300" },
      width: 100,
      render: (_, raw) => (
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          <CountUp end={raw?.uniqueSearches} />
        </span>
      ),
    },
    {
      title: TitleValue("Paragraphs"),
      dataIndex: "paragraph",
      sorter: (a, b) => a?.paragraphs - b?.paragraphs,
      align: "center",
      style: { fontSize: "13px", fontWeight: "300" },
      width: 100,
      render: (_, raw) => (
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          <CountUp end={raw?.paragraphs} />
        </span>
      ),
    },
  ];

  React.useEffect(() => {
    setChannelId(null);
    setSlackData(null);
    setChannel(false);
  }, [
    domainId,
    geoLevelId,
    geoLevelValue,
    check,
    documentUserType.userType.value,
  ]);
  const fetchSlackData = () => {
    setLoading(true);
    Fetch_Document(
      geoLevelId,
      geoLevelValue !== undefined ? geoLevelValue : ``,
      documentUserType.userType.value !== null
        ? documentUserType.userType.value
        : ``,
      domainId,
      channelId,
      channel
    ).then((res) => {
      if (res === undefined) return;
      setLoading(false);
      setThreadRefresh(false);
      setSlackData(res?.data?.data);
      // setCurrentPage(1);
    });
    // setIsRefreshing(true);
  };

  const fetchData = (channleIdValue, channelBool) => {
    setLoading(true);
    Fetch_Document(
      geoLevelId,
      geoLevelValue !== undefined ? geoLevelValue : ``,
      documentUserType.userType.value !== null
        ? documentUserType.userType.value
        : ``,
      domainId,
      channleIdValue,
      channelBool
    ).then((res) => {
      if (res === undefined) return;
      setReload(false);
      setLoading(false);
      setThreadRefresh(false);
      setSlackData(res?.data?.data);
    });
    setIsRefreshing(false);
  };
  const changeMore = () => {
    setIsRefreshing(false);
    setSlackData(null);
    setChannel(false);
  };

  React.useEffect(() => {
    // setLoading(true);
    if (check !== "") {
      setLoading(true);
      Fetch_Document(
        geoLevelId,
        geoLevelValue !== undefined ? geoLevelValue : ``,
        documentUserType.userType.value !== null
          ? documentUserType.userType.value
          : ``,
        domainId
      ).then((res) => {
        if (res === undefined) return;
        setLoading(false);
        setDocumentData(res?.data?.data);
      });
    }
    // setLoading(false);
    setIsRefreshing(false);
    setCurrentPage(1);
    setReload(false);
    setShowMore();
  }, [
    domainId,
    geoLevelId,
    geoLevelValue,
    check,
    documentUserType.userType.value,
    // channelId,
    // channel,
  ]);

  const refreshData = () => {
    setThreadRefresh(true);
    fetchData(channelId, true);
  };
  // console.log("loading", documentData);
  return (
    <div style={containerStyle}>
      <div style={{ paddingBottom: "10px", marginTop: "15px" }}>
        {channel && (
          <div
            style={{
              display: "flex",
              width: "100%",
              paddingTop: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "46%",
                justifyContent: "flex-start",
              }}
            >
              <ArrowBackIcon
                style={{ cursor: "pointer" }}
                onClick={changeMore}
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "53.666%",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  fontSize: "18px",
                  color: "#2A364A",
                  fontWeight: "500",
                  marginLeft: "5px",
                }}
              >
                {channelName}
              </span>
              <Tooltip
                color="#fff"
                title={() => {
                  return (
                    <span
                      style={{ color: "black", textTransform: "capitalize" }}
                    >
                      Refresh
                    </span>
                  );
                }}
              >
                <span style={{ paddingRight: "2git px" }}>
                  <SyncOutlined
                    colSpan={3}
                    span={2}
                    onClick={() => refreshData()}
                    spin={threadRefresh}
                    style={{ fontSize: "16px" }}
                  />
                </span>
              </Tooltip>
            </div>
          </div>
        )}

        <Spin
          spinning={loading}
          style={{
            width: "100%",
            paddingTop: "15px",
          }}
        >
          <div>
            <StaticTableAnt
              columns={
                channel && slackData !== null ? slackColumnData : columnsData
              }
              data={channel ? slackData : documentData}
              searchValue={channel && slackData !== null ? "" : searchValue}
              setSearchValue={setSearchValue}
              count={count}
              // Header="Seeker Search Statistics"
              currentPage={channel ? slackCurrentPage : currentPage}
              setCurrentPage={channel ? setSlackCurrentPage : setCurrentPage}
              isRefreshing={channel === false ? isRefreshing : false}
              setIsRefreshing={setIsRefreshing}
              showRefresh={true}
              fetchData={channel ? fetchSlackData : fetchData}
              setShowMore={setShowMore}
              searchBoolean={channel === true ? false : true}
              channel={channel}
              setFilteredInfo={setFilteredInfo}
              sortInfo={sortInfo}
              setSortInfo={setSortInfo}
            />
          </div>
        </Spin>
      </div>
    </div>
  );
}

export default DocumentTable;
